import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Terms of Service</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">Terms of Service</h1>
            <p className="text-foreground-600">Last updated: August 2026</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-6 text-foreground-700">
            <p>By accessing and using cssbuybr.help, you accept and agree to be bound by these Terms of Service.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Use of Website</h2>
            <p>This website is an independent resource hub for CSSBuy Spreadsheet information. We provide guides, reviews, and educational content only. We do not process orders, handle payments, or operate as a shopping agent.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Independent Resource</h2>
            <p>cssbuybr.help is not affiliated with, endorsed by, or connected to CSSBuy. All content is created independently for educational purposes.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">External Links</h2>
            <p>Our website contains links to third-party websites, including kaspreadsheet.com. We are not responsible for the content, accuracy, or practices of these external sites.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Content Accuracy</h2>
            <p>While we strive to provide accurate and up-to-date information, we make no warranties about the completeness, reliability, or accuracy of our content. Shipping costs, prices, and policies may change without notice.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Limitation of Liability</h2>
            <p>We are not liable for any losses, damages, or issues arising from your use of this website or reliance on its content. Always verify critical information through official channels.</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}